import CtaItem from "../hm-stage/ctaItem.vue"

const config = {
  name: 'HmLink',
  setting: [
    {
      label: '文案',
      key: 'cta',
      component: function (h, { key }){
        return <CtaItem  v-model={this.value[key]}></CtaItem>
      },
      value: {
        desc: '文案',
        urlData: {}
      }
    },
  ],
  transformIn: (v) => {
    const {
      name,
      base,
      config
    } = v
    return {
      name,
      ...base,
      ...config
    }
  },
  transformOut:(v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
        })
      },
      config: (v) => {
        return pickBy(v, {
          cta: 'cta',
        })
      }
    })
  }
}
export default config
